import React from "react";

const HowItWork = () => {
  return (
    <div
      className="section-full site-bg-light twm-how-it-work-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="section-content">
        <div className="twm-how-it-work-section container-fluid">
          <div className="row">

            {/* Left Image */}
            <div className="col-lg-6 col-md-12">
              <div className="twm-how-it-work-media">
                <img src="/images/h-it-work.jpg" alt="How Velocity Cab Works" />
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6 col-md-12">
              <div className="twm-how-it-work-content">

                {/* Title */}
                <div className="section-head left">
                  <div className="twm-sm-title left">How It Works</div>
                  <h2 className="twm-large-title site-text-dark">
                    Book Your Cab in 4 Easy Steps
                  </h2>
                </div>

                <div className="row">

                  {/* Step 1 */}
                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">
                      <div className="twm-w-step-count">
                        <span>01</span>
                      </div>
                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">Enter Ride Details</h3>
                        <p>
                          Enter your pickup and drop location with date and time to begin your booking process easily.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Step 2 */}
                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">
                      <div className="twm-w-step-count">
                        <span>02</span>
                      </div>
                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">Choose Your Cab</h3>
                        <p>
                          Select your preferred cab based on comfort, budget, and travel needs from available options.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Step 3 */}
                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">
                      <div className="twm-w-step-count">
                        <span>03</span>
                      </div>
                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">Confirm Booking</h3>
                        <p>
                          Review your trip details and confirm your booking quickly with our simple and secure system.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Step 4 */}
                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">
                      <div className="twm-w-step-count">
                        <span>04</span>
                      </div>
                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">Enjoy Your Ride</h3>
                        <p>
                          Relax and enjoy your journey while our driver ensures safe, comfortable, and timely travel.
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWork;